import React, { Suspense, Fragment, useState } from "react";
import { Route } from "react-router-dom";
import Header from '../../components/header/index';
import Sidenav from '../../components/sidenav/index';
import WebSideNav from "../../components/sidenav/webSideNav";
import Loading from "../../components/loading";

import "../innerLayout.css";

const PublicLayout = (props) => {

    return <div className="App-div">
          <div className="appBar">
            <div className="appIconBox" onClick={props.handleSlide}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="brandingBox">
                <div className="logoBox">
                    <img src="/images/logos/logo.png" className="lgLogo invertWhite" alt="logo" />
                </div>
            </div>
            
        </div>
    <Suspense fallback={<Loading />}>
        <Route exact path={props.path} component={props.component} {...props} />
    </Suspense>
</div>
}

export default PublicLayout;
